import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["type"];
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// pkg/dist-src/index.js
import { getUserAgent } from "universal-user-agent";
import { request } from "@octokit/request"; // pkg/dist-src/auth.js

import btoa from "btoa-lite";
import { createOAuthUserAuth } from "@octokit/auth-oauth-user";

function auth(_x, _x2) {
  return _auth.apply(this, arguments);
} // pkg/dist-src/hook.js


function _auth() {
  _auth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state, authOptions) {
    var _authOptions$state, type, options, common, userAuth;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(authOptions.type === "oauth-app")) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", {
              type: "oauth-app",
              clientId: state.clientId,
              clientSecret: state.clientSecret,
              clientType: state.clientType,
              headers: {
                authorization: "basic ".concat(btoa("".concat(state.clientId, ":").concat(state.clientSecret)))
              }
            });

          case 2:
            if (!("factory" in authOptions)) {
              _context.next = 5;
              break;
            }

            _authOptions$state = _objectSpread(_objectSpread({}, authOptions), state), type = _authOptions$state.type, options = _objectWithoutProperties(_authOptions$state, _excluded);
            return _context.abrupt("return", authOptions.factory(options));

          case 5:
            common = _objectSpread({
              clientId: state.clientId,
              clientSecret: state.clientSecret,
              request: state.request
            }, authOptions);

            if (!(state.clientType === "oauth-app")) {
              _context.next = 12;
              break;
            }

            _context.next = 9;
            return createOAuthUserAuth(_objectSpread(_objectSpread({}, common), {}, {
              clientType: state.clientType
            }));

          case 9:
            _context.t0 = _context.sent;
            _context.next = 15;
            break;

          case 12:
            _context.next = 14;
            return createOAuthUserAuth(_objectSpread(_objectSpread({}, common), {}, {
              clientType: state.clientType
            }));

          case 14:
            _context.t0 = _context.sent;

          case 15:
            userAuth = _context.t0;
            return _context.abrupt("return", userAuth());

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _auth.apply(this, arguments);
}

import btoa2 from "btoa-lite";
import { requiresBasicAuth } from "@octokit/auth-oauth-user";

function hook(_x3, _x4, _x5, _x6) {
  return _hook.apply(this, arguments);
} // pkg/dist-src/version.js


function _hook() {
  _hook = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(state, request2, route, parameters) {
    var endpoint, credentials;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            endpoint = request2.endpoint.merge(route, parameters);

            if (!/\/login\/(oauth\/access_token|device\/code)$/.test(endpoint.url)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", request2(endpoint));

          case 3:
            if (!(state.clientType === "github-app" && !requiresBasicAuth(endpoint.url))) {
              _context2.next = 5;
              break;
            }

            throw new Error("[@octokit/auth-oauth-app] GitHub Apps cannot use their client ID/secret for basic authentication for endpoints other than \"/applications/{client_id}/**\". \"".concat(endpoint.method, " ").concat(endpoint.url, "\" is not supported."));

          case 5:
            credentials = btoa2("".concat(state.clientId, ":").concat(state.clientSecret));
            endpoint.headers.authorization = "basic ".concat(credentials);
            _context2.prev = 7;
            _context2.next = 10;
            return request2(endpoint);

          case 10:
            return _context2.abrupt("return", _context2.sent);

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](7);

            if (!(_context2.t0.status !== 401)) {
              _context2.next = 17;
              break;
            }

            throw _context2.t0;

          case 17:
            _context2.t0.message = "[@octokit/auth-oauth-app] \"".concat(endpoint.method, " ").concat(endpoint.url, "\" does not support clientId/clientSecret basic authentication.");
            throw _context2.t0;

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[7, 13]]);
  }));
  return _hook.apply(this, arguments);
}

var VERSION = "7.0.1"; // pkg/dist-src/index.js

import { createOAuthUserAuth as createOAuthUserAuth2 } from "@octokit/auth-oauth-user";

function createOAuthAppAuth(options) {
  var state = Object.assign({
    request: request.defaults({
      headers: {
        "user-agent": "octokit-auth-oauth-app.js/".concat(VERSION, " ").concat(getUserAgent())
      }
    }),
    clientType: "oauth-app"
  }, options);
  return Object.assign(auth.bind(null, state), {
    hook: hook.bind(null, state)
  });
}

export { createOAuthAppAuth, createOAuthUserAuth2 as createOAuthUserAuth };